import { createContext, useState, useEffect, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const localToken = localStorage.getItem("token");
  const localCategory = localStorage.getItem('category');
  const localSu_flag = localStorage.getItem('su_flag');
  const [token, setToken] = useState(localToken);
  const [category, setCategory] = useState(localCategory);
  const [su_flag, setSu_flag] = useState(localSu_flag);
  const [loading, setLoading] = useState(true);
  //const [user, setUser] = useState('');
  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem("token");
    if (token) {
      setToken(token);
      //setUser({token});
    }
    setLoading(false);
  };

  const login = (token,category, su_flag) => {
    localStorage.setItem("token", token);
    localStorage.setItem('category', category);
    localStorage.setItem('su_flag', su_flag);
    setToken(token);
    setCategory(category);
    setSu_flag(su_flag);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("category");
    localStorage.removeItem("su_flag");
    setToken(null);
    setCategory(null);
    setSu_flag(null);
  };

  const getToken = () => token;

  return (
    <AuthContext.Provider
      value={{
        token,
        category,
        su_flag,
        loading,
        login,
        logout,
        isAuthenticated: !!token,
        getToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
